import { AppButton } from '../../../forms';

export interface IFormActionProps {
  mainCTA: {
    label: string;
    onClick: () => void;
  };
  otherCTA?: {
    label: string;
    onClick: () => void;
  };
}

/**
 * -----------------------------------------------------------------------------
 * It renders a form action with a main and other CTA buttons
 */
export function FormAction({ mainCTA, otherCTA }: Readonly<IFormActionProps>) {
  return (
    <div>
      <div className="flex justify-end gap-2">
        {otherCTA ? (
          <AppButton
            onClick={otherCTA?.onClick}
            size="small"
            title={otherCTA?.label}
            type="outlined"
            variants="default"
          />
        ) : null}
        <AppButton
          onClick={mainCTA.onClick}
          size="small"
          title={mainCTA.label}
        />
      </div>
    </div>
  );
}
